import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent } from './firebase';

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackEvent('page_view', {
      page_path: location.pathname + location.search,
    });
  }, [location]);

  return null;
};

export default PageTracker;
